<template>
  <div>
    <v-card class="py-3 mb-4">
      <v-card-title>
        <span class="title">
          {{ $t('reports.priceComparison.title') }}
        </span>
      </v-card-title>
      <v-card-subtitle>
        <span class="subheading">
          {{ $t('reports.priceComparison.description') }}
        </span>
      </v-card-subtitle>
      <v-card-text>
        <span class="body-2">
          {{ $t('reports.priceComparison.chooseProduct') }}
        </span>
        <div class="d-flex justify-center">
          <v-autocomplete
            v-model="selectedProduct"
            :label="$t('reports.priceComparison.products')"
            :items="this.products"
            return-object
          />
        </div>
      </v-card-text>
      <v-card-actions class="d-flex align-center justify-center">
        <v-btn @click="generateComparative" color="primary darken-1" :disabled="!canContinue">
          {{ $t('reports.priceComparison.generateComparative') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :color="snackBarColor" :timeout="3000">
      <span class="body-1">
        {{ snackbarText }}
      </span>
    </v-snackbar>
    <v-divider/>
    <v-card class="py-3">
      <v-card-title>
        <span class="title">
          {{ $t('reports.priceComparison.results') }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="comparedProducts"
          :sort-by="['createdAt']"
          :sort-desc="[true]"
          class="elevation-1"
        >
          <template v-slot:item.aliases="{ item }">
            <div v-for="alias in item.aliases" :key="alias" class="d-flex flex-column">
              <span class="body-2">{{ alias }}</span>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'PriceComparison',
  data () {
    return {
      loading: false,
      snackbar: false,
      snackbarText: '',
      snackBarColor: null,
      selectedProduct: null,
      products: [],
      itemsPerPage: 0,
      headers: [
        { text: this.$t('reports.priceComparison.table.headers.date'), value: 'createdAt' },
        { text: this.$t('reports.priceComparison.table.headers.product'), value: 'productName' },
        { text: this.$t('reports.priceComparison.table.headers.unit'), value: 'unit' },
        { text: this.$t('reports.priceComparison.table.headers.unitPrice'), value: 'productUnitPrice' },
        { text: this.$t('reports.priceComparison.table.headers.category'), value: 'category' },
        { text: this.$t('reports.priceComparison.table.headers.provider'), value: 'provider' },
        { text: this.$t('reports.priceComparison.table.headers.aliases'), value: 'aliases' }
      ],
      comparedProducts: []
    }
  },
  computed: {
    restaurant () {
      return this.$store.state.currentRestaurant.data
    },
    canContinue () {
      return this.selectedProduct !== null
    }
  },
  async mounted () {
    await this.loadProducts()
  },
  methods: {
    showSnackBar (message, success) {
      this.snackBarColor = success ? 'success darken-1' : 'error darken-1'
      this.snackbarText = message
      this.snackbar = true
    },
    async loadProducts () {
      try {
        this.products = await this.$api.get(`/v1/restaurants/${this.restaurant._id}/reports/products`)
      } catch (error) {
        this.showSnackBar(error.message, false)
      }
    },
    async generateComparative () {
      this.loading = true
      try {
        const response = await this.$api.post(`/v1/restaurants/${this.restaurant._id}/reports/product-price-comparison`, {
          productName: this.selectedProduct
        })
        this.comparedProducts = response
        this.itemsPerPage = response.length
        this.showSnackBar(this.$t('reports.priceComparison.success'), true)
      } catch (error) {
        this.showSnackBar(error.message, false)
      }
    }
  }
}
</script>
